
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/evaluation-by-locality",
      function () {
        return require("private-next-pages/evaluation-by-locality.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/evaluation-by-locality"])
      });
    }
  